/**
 * @module DiagnosticsPreview
 */

import Component from '../base/Component';
import './styles.css';

import Rating from '../base/Rating';

/**
 * Превью страницы диагностики.
 */
export default class DiagnosticsPreview extends Component {
    static className = 'diagnostics-preview';

    initElements() {
        this.elements = {
            $rating: $('.rating', this.$block),
        };
    }

    init(options) {
        super.init(options);

        this.setRating();
    }

    setRating() {
        const rating = new Rating(this.elements.$rating);

        rating.init();
    }
}
